
import { Component, Vue } from "vue-property-decorator";
import QuestionnaireStepHeader from "./QuestionnaireStepHeader.vue";
import QuestionnaireStepBody from "./QuestionnaireStepBody.vue";
import QuestionnaireStepActions from "./QuestionnaireStepActions.vue";
import { SMQuestionnaire, SMUser, SMCases } from "@/store";

const HOME_PATH = "/home";
const CASES_PATH = "/cases";
const ROLES_PATH = "/roles";

@Component({
  components: {
    QuestionnaireStepHeader,
    QuestionnaireStepBody,
    QuestionnaireStepActions,
  },
})
export default class QuestionnaireStep extends Vue {
  completePopup = false;

  get caseId(): number {
    const id = Number(localStorage.getItem("case_id"));

    return id || SMCases.currentCaseId || Number(this.$route.params.id ?? 0);
  }

  get isRoleRoute(): boolean {
    return this.$route.path.includes(ROLES_PATH);
  }

  get defaultPath() {
    if (!SMUser.isCandidate) {
      return `${SMUser.basePath}${HOME_PATH}`;
    }

    return this.caseId ? `${CASES_PATH}/${this.caseId}` : CASES_PATH;
  }

  closeAndRedirectHomePage() {
    SMQuestionnaire.close();

    // if (this.isRoleRoute) return;

    // const previousPath = SMApp.previousRouterHistoryPath
    //   ? SMApp.previousRouterHistoryPath
    //   : this.defaultPath;

    // this.$router.push(previousPath);
  }

  openCompletePopup() {
    this.completePopup = true;
  }

  closeCompletePopup() {
    this.completePopup = false;
  }
}
